import React from 'react'
import { Menu, MenuButton } from '@chakra-ui/react'
import { MdMoreVert } from 'react-icons/md'
import PropTypes from 'prop-types'
import CustomMenuList from './CustomMenuList/CustomMenuList'

const MoreMenu = ({ actions, iconSize, onClick }) => {
  const handleMoreMenuClick = e => {
    e.stopPropagation()
    onClick(e)
  }
  return (
    <Menu zIndex={3000}>
      <MenuButton
        onClick={handleMoreMenuClick}
        padding={1}
        borderRadius="50%"
        _hover={{
          color: 'gray',
          background: 'brand.lightestGray',
        }}>
        <MdMoreVert size={iconSize} />
      </MenuButton>
      <CustomMenuList items={actions} />
    </Menu>
  )
}

MoreMenu.propTypes = {
  iconSize: PropTypes.number,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      action: PropTypes.func,
      label: PropTypes.string,
    }),
  ),
}

export default MoreMenu
